import { createContext, useState, useMemo } from "react";
import { createTheme } from "@mui/material/styles";
import { color, typography } from "@mui/system";

//color design tokens

// mui theme settings

export const themeSettings = (mode) => {
    return {
        palette: {
            logo: '../assets/images/logos/franchising-logo.png',
            mode: mode,
            ...(mode === 'dark'
                ? {
                    primary: {
                        main: '#FF4364',
                        rgba: 'rgba(255,67,100,0.3)'
                    },
                    secondary: {
                        main: '#1ADDFF',
                        rgba: 'rgba(29,160,255,0.3)'
                    },
                    tertiary: {
                        main: '#FFA300',
                        rgba: 'rgba(255,163,0,0.3)'
                    },
                    background: {
                        default: '#fff',
                        paper: '#eee',
                    },
                    warning: {
                        main: '#ed6c02',
                        light: '#ff9800',
                        dark: '#e65100'
                    },
                    sucess: {
                        main: '#2e7d32',
                        light: '#4caf50',
                        dark: '#1b5e20',
                    },
                    error: {
                        main: '#f44336',
                        light: '#e57373',
                        dark: '#d32f2f'
                    },
                    text: {
                        primary: '#757575',
                        secondary: 'rgba(0, 0, 0, 0.6)',
                        disabled: 'rgba(0, 0, 0, 0.38)',
                        inverse: '#fff'
                    }
                } : {
                    primary: {
                        main: '#FF4364',
                        rgba: 'rgba(255,67,100,0.3)'
                    },
                    secondary: {
                        main: '#1ADDFF',
                        rgba: 'rgba(29,160,255,0.3)'
                    },
                    tertiary: {
                        main: '#FFA300',
                        rgba: 'rgba(255,163,0,0.3)'
                    },
                    background: {
                        default: '#1E1E1E',
                        paper: '#565656',
                    },
                    warning: {
                        main: '#ed6c02',
                        light: '#ff9800',
                        dark: '#e65100'
                    },
                    sucess: {
                        main: '#2e7d32',
                        light: '#4caf50',
                        dark: '#1b5e20',
                    },
                    error: {
                        main: '#FF7A00',
                        light: '#e57373',
                        dark: '#d32f2f'
                    },
                    text: {
                        primary: '#fff',
                        secondary: 'rgba(255, 255, 255, 0.7)',
                        disabled: 'rgba(255, 255, 255, 0.5)',
                        inverse: 'rgba(0, 0, 0, 0.87)'
                    }
                }
            )
        },
        typography: {
            fontFamily: ["Public Sans", "sans-serif"].join(","),
            fontSize: 12,
            h1: {
                fontFamily: ["Public Sans", "sans-serif"].join(","),
                fontSize: 40,
            },
            h2: {
                fontFamily: ["Public Sans", "sans-serif"].join(","),
                fontSize: 32,
            },
            h3: {
                fontFamily: ["Public Sans", "sans-serif"].join(","),
                fontSize: 24,
            },
            h4: {
                fontFamily: ["Public Sans", "sans-serif"].join(","),
                fontSize: 20,
            },
            h5: {
                fontFamily: ["Public Sans", "sans-serif"].join(","),
                fontSize: 16,
            },
            h6: {
                fontFamily: ["Public Sans", "sans-serif"].join(","),
                fontSize: 14,
            }
        }
    }
}

// context

export const ColorModeContext = createContext({
    toggleColorMode: () => {

    }
})

export const useMode = () => {
    const [mode, setMode] = useState("light")
    const colorMode = useMemo(
        () => ({
            toggleColorMode: () => setMode((prev) => (prev === 'dark' ? 'light' : 'dark'))
        })
    )

    const theme = useMemo(() => createTheme(themeSettings(mode)), [mode])

    return [theme, colorMode]
}